export default __webpack_public_path__ + "static/media/baner.e0baf788.jpg";